import validate from 'validate.js';
import { getErrors } from '../error/getErrors';
import { isValid } from '../error/isValid';
import { formAddProfSchema } from '../error/schemas/formAddProf';

export const addProfFormErrorHandling = (prof, field, value) => {
  let errors = prof.errors;

  const message = validate({ [field]: value }, formAddProfSchema);
  errors = getErrors(
    errors,
    field,
    message && message[field] && message[field][0]
  );

  return {
    ...prof,
    values: {
      ...prof.values,
      [field]: value
    },
    errors,
    isValid: isValid(errors)
  };
};
